export default __webpack_public_path__ + "static/media/img-quality-roast.df0efba7.png";